import * as React from 'react';
import { ModalFilter, Status as StatusInterface } from '../types';
import FilterModal from './FilterModal';
import DropDownFilter from './DropDownFilter';
import { useDispatch, useSelector } from 'react-redux';
import * as DataActions from '../redux/actions/data';
import * as FilterActions from '../redux/actions/filters';
import { formatDateFilter } from '../helpers/format';
import { ReduxStates } from '../redux/reduxTypes';

export interface FiltersHeaderProps {
  marketFilters: (ModalFilter | null)[];
  setDateFilter: (arg1: any) => void;
  setCustomRangeFilter: (arg1: any) => void;
  status?: StatusInterface | StatusInterface[] | null;
  dateFilter: string;
  customRangeFilter: (string | number)[] | null;
  clearLocalData?: () => void;
  setCurrentPage?: (value: React.SetStateAction<number>) => void;
}

const FiltersHeader: React.FC<FiltersHeaderProps> = ({
  marketFilters,
  dateFilter,
  customRangeFilter,
  setDateFilter,
  setCustomRangeFilter,
  clearLocalData,
  setCurrentPage
}) => {
  const dispatch = useDispatch();
  const data = useSelector((state: ReduxStates) => state.data);
  const copyData = useSelector((state: ReduxStates) => state.copyData);
  const [currencyFilters, setCurrencyFilters] = React.useState<Array<string> | null>(null);

  React.useEffect(() => {
    if (data && data.currencies) {
      const formattedCurrencyList = data.currencies.map((currency: any) => currency.currencyCode);
      setCurrencyFilters(formattedCurrencyList);
    }
  }, [data]);

  return (
    <div className="flex justify-between w-full h-[40px]">
      <div className="flex space-x-1.5">
        <FilterModal
          values={marketFilters}
          onUpdate={(filters) => {
            dispatch(FilterActions.setMarketFilters(filters));
          }}
        />
        <DropDownFilter
          className="shadow-filterModalShadow"
          key={0}
          options={
            currencyFilters ? currencyFilters.sort() : data.defaultCurrency ? [data.defaultCurrency] : ['No Options']
          }
          onChange={(option) => {
            if (option !== 'No Options' && option != data.selectedCurrency) {
              clearLocalData && clearLocalData();
              dispatch(DataActions.setSelectedCurrency(option));
            }
          }}
          value={data.selectedCurrency || ''}
          variant="small"
          automationID="global_currency_picker"
          scrollable={true}
        />
      </div>
      <div className="flex items-center">
        <DropDownFilter
          variant="globalDateFilter"
          isDateFilter
          value={
            data.dateFilterRangeLimit
              ? formatDateFilter(dateFilter, customRangeFilter || undefined, copyData, data.dateFilterRangeLimit)
              : ''
          }
          onChange={(option: string, customRange: Array<number | string> | undefined) => {
            // update date filters
            // clearLocalData && clearLocalData();
            setCurrentPage && setCurrentPage(0);
            setDateFilter(option);
            dispatch(FilterActions.setDatesFilters({ range: option }));
            if (customRange) {
              setCustomRangeFilter(customRange);
              dispatch(FilterActions.setDatesFilters({ range: option, custom: customRange }));
            } else {
              setCustomRangeFilter(null);
            }
          }}
          automationID="global_date_picker"
        />
      </div>
    </div>
  );
};

export default FiltersHeader;
